import { get, post, put, del } from "../request";

/**
 * 教师端课程相关接口（education-course-admin）
 * - 教师课程管理 Course Teacher Controller → /courseAdmin/courseTeacher
 * - 章节管理 / 课时管理 → /courseAdmin/courseChapter、courseChapterClass
 * 不使用管理端 /courseAdmin/course/*、/courseAdmin/course/statistics/*（非 teacher）
 */
const COURSE_TEACHER = "/courseAdmin/courseTeacher";

// ==================== 教师课程管理 ====================

/** 分页查询我的教师课程列表 GET /courseTeacher/my-list */
export function getCourseList(params) {
  return get(`${COURSE_TEACHER}/my-list`, params);
}

/** 查询课程详情 GET /courseTeacher/{courseCode} */
export function getCourseDetail(courseCode) {
  return get(`${COURSE_TEACHER}/${courseCode}`);
}

/** 新增课程 POST /courseTeacher */
export function addCourse(data) {
  return post(COURSE_TEACHER, data);
}

/** 修改课程 PUT /courseTeacher（含 videoPercent 等字段） */
export function updateCourse(data) {
  return put(COURSE_TEACHER, data);
}

/** 删除课程 DELETE /courseTeacher/{courseCode} */
export function deleteCourse(courseCode) {
  return del(`${COURSE_TEACHER}/${courseCode}`);
}

/** 克隆课程 POST /courseTeacher/{courseCode}/clone?courseName= */
export function cloneCourse(courseCode, courseName) {
  return post(
    `${COURSE_TEACHER}/${courseCode}/clone`,
    {},
    { params: { courseName } }
  );
}

/** 查询课程指定学员 GET /courseTeacher/members */
export function getCourseMembers(params) {
  return get(`${COURSE_TEACHER}/members`, params);
}

/**
 * 给课程指定学员 POST /courseTeacher/assignMembers
 * body: { courseCode, memberCodes: string[] }
 */
export function updateCourseMembers(data) {
  return post(`${COURSE_TEACHER}/assignMembers`, data);
}

/** 修改课程状态 PUT /courseTeacher/updateStatusCourse（上架等） */
export function updateCourseStatus(data) {
  return put(`${COURSE_TEACHER}/updateStatusCourse`, data);
}

/** 课程下架 PUT /courseTeacher/offline/{courseCode} */
export function offlineCourse(courseCode) {
  return put(`${COURSE_TEACHER}/offline/${courseCode}`);
}

/** 查询课程考试信息（train 服务，编辑页沿用） */
export function getCourseExam(id) {
  return get("/trainAdmin/courseQuestion/queryInfo", { courseId: id });
}

/** 保存课程考试配置 */
export function addCourseExam(params) {
  return post("/trainAdmin/courseQuestion/saveTest", params);
}

/** 查询培训机构列表 */
export function getSchools(params) {
  return get("/trainAdmin/trainAdmin/list", params);
}

// ==================== 章节管理 ====================

export function getChapterList(params) {
  return get("/courseAdmin/courseChapter/list", params);
}

export function getChapterDetail(chapterId) {
  return get(`/courseAdmin/courseChapter/${chapterId}`);
}

export function addChapter(data) {
  return post("/courseAdmin/courseChapter", data);
}

export function updateChapter(data) {
  return put("/courseAdmin/courseChapter", data);
}

export function deleteChapter(chapterCode) {
  return del(`/courseAdmin/courseChapter/${chapterCode}`);
}

// ==================== 课时管理 ====================

export function getChapterClassList(params) {
  return get("/courseAdmin/courseChapterClass/list", params);
}

export function getChapterClassDetail(classId) {
  return get(`/courseAdmin/courseChapterClass/${classId}`);
}

export function addChapterClass(data) {
  return post("/courseAdmin/courseChapterClass", data);
}

export function updateChapterClass(data) {
  return put("/courseAdmin/courseChapterClass", data);
}

export function deleteChapterClass(classCode) {
  return del(`/courseAdmin/courseChapterClass/${classCode}`);
}

// ==================== 资源管理 ====================

export function addResource(data) {
  return post("/resourcesAdmin/resourcesAdmin", data);
}



// WEBPACK FOOTER //
// ./src/api/course/index.js